import * as React from "react";

const usePagination = (size = 10) => {
  const paginationInitialState = {
    page: 0,
    size,
  };

  const paginationReducer = (state, { type, payload }) => {
    switch (type) {
      case "CHANGE_PAGE":
        return { ...state, page: payload };
      default:
        return state;
    }
  };

  const [paginationState, paginationDispatch] = React.useReducer(
    paginationReducer,
    paginationInitialState
  );

  const changePage = (page) => {
    paginationDispatch({ type: "CHANGE_PAGE", payload: page });
  };

  return [paginationState, changePage];
};

export default usePagination;
